$(function () {
	$('.js-back').on('click', function() {
		window.history.back();
		return false;
	});
});
